<script>
    import { Router, Link, Route } from "svelte-navigator";
    import OfferForm from "./OfferForm.svelte";
    import PreviewCanvas from "./PreviewCanvas.svelte";
</script>

<Router primary={false}>
    <div>
        <Route path="/">
            <OfferForm />
        </Route>
        <Route path="preview/:id" component={PreviewCanvas}>
        </Route>
    </div>
</Router>